export default __webpack_public_path__ + "static/media/binaryHover.4986ef37.svg";